import { useContext } from 'react';

import { SssApiCreditsClientContext, SssApiCreditsContext } from './SssApiCreditsClientProvider';

export const useSssApiCreditsClient = (): SssApiCreditsContext => {
  const context = useContext(SssApiCreditsClientContext);

  if (context === null) {
    throw new Error('useSSSApiCreditsClient must be used within a SssApiCreditsClientProvider');
  }

  return context;
};
